import { Image, ImageProps } from '@doveit/lego';
import React from 'react';
import { getAbsoluteAssetURI } from '../../utils/assetsUtils';
import Markdown from '../markdown/Markdown';
import * as styles from './Intro.style';

export type IntroProps = React.PropsWithChildren<{
  title: string,
  description: string,
  image?: ImageProps,
}>;

const Intro: React.FC<IntroProps> = ({
  title,
  description,
  image,
  children,
}) => (
  <div>
    <h1 css={styles.title}>
      <Markdown>{title}</Markdown>
    </h1>
    <div css={styles.content}>
      <div
        css={styles.intro}
        $image={image}
      >
        <div css={styles.description}>
          <Markdown>
            {description}
          </Markdown>
        </div>
        {children && (
          <div css={styles.children}>
            {children}
          </div>
        )}
      </div>
      {image && (
        <div css={styles.imageBox}>
          <div css={styles.image}>
            <Image
              {...image}
              src={getAbsoluteAssetURI(image.src)}
              lazyLoad
              fit
            />
          </div>
        </div>
      )}
    </div>
  </div>
);

export default Intro;
